<template>
  <Screen
    center-transparent
    back-button
    back-button-text="Go back to home"
    :back-button-route="`/`"
  >
    <div
      slot="screen-center"
      class="error-404"
    >
      <div class="error-404__text">
        <h1>404</h1>
        <h2>Sorry... we could not find the page you are looking for.</h2>
        <router-link to="/">
          Go back to home
        </router-link>
      </div>
    </div>
  </Screen>
</template>

<script>
import Screen from '@/components/Screen.vue'

export default {
  name: 'ErrorPage404',

  components: {
    Screen
  }
}
</script>

<style lang="scss" scoped>
.error-404 {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  text-align: center;
}

.error-404__text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: $spacer-unit-x4;

  h1 {
    font-size: $spacer-unit-x16;
  }

  h1,
  h2 {
    margin-bottom: $spacer-unit-x4;
  }

  a {
    color: $blue;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
